import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from '@app-services/product.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { LinkTypeStatsClick } from '@app-model/linkTypeStatsClick';
import { ProductInfo } from '@app-model/product';
import { withLoading } from '@app-shared/rxjs/with-loading.operator';
import { switchMap, take, tap } from 'rxjs/operators';

@Component({
	selector: 'app-public-footer',
	templateUrl: './public-footer.component.html',
	styleUrls: ['./public-footer.component.scss']
})
export class PublicFooterComponent implements OnInit {
	productInfo: ProductInfo;
	@Input() pageType: 'property' | 'search' | 'showcase' = 'property';
	linkType = LinkTypeStatsClick;
	env = environment;
	loadingLanguage = true;

	constructor(private readonly productService: ProductService, public readonly translate: TranslateService) {}

	ngOnInit(): void {
		this.productService
			.getProductInfo()
			.pipe(
				take(1),
				tap(info => (this.productInfo = info)),
				switchMap(info => this.translate.use(info.language)),
				withLoading(v => (this.loadingLanguage = v))
			)
			.subscribe();
	}

	get currentYear(): number {
		return new Date().getFullYear();
	}

	get footerLinkType(): LinkTypeStatsClick {
		switch (this.pageType) {
			case 'property':
				return LinkTypeStatsClick.PROPERTY_FOOTER_POWERED_BY;
			case 'search':
				return LinkTypeStatsClick.SEARCH_FOOTER_POWERED_BY;
			case 'showcase':
				return LinkTypeStatsClick.SHOWCASE_FOOTER_POWERED_BY;
			default:
				return LinkTypeStatsClick.PROPERTY_FOOTER_POWERED_BY;
		}
	}
}
